import * as Sentry from '@sentry/react';
import { config } from '../config';
import { ApolloError } from '@apollo/client';

// Initialize Sentry for error reporting
// Note: Amplitude init is now in RobinLoggerContext
Sentry.init({
  enabled: config.env !== 'development',
  environment: config.env,
  dsn: config.sentryDsn,
  tracesSampleRate: 1.0,
  normalizeDepth: 10,
});

/**
 * Logs an error to Sentry.
 * Only captures exceptions if the environment is not 'development'.
 * @param e The error object (Error or ApolloError).
 */
export const setSentryUser = (context: {
  azureAdId?: string;
  robinUserId?: string;
  tenantId?: string;
}) => {
  Sentry.setUser({
    id: context.azureAdId,
    username: context.robinUserId,
  });
  if (context.azureAdId) Sentry.setTag('azureAdId', context.azureAdId);
  if (context.robinUserId) Sentry.setTag('robinUserId', context.robinUserId);
  if (context.tenantId) Sentry.setTag('tenantId', context.tenantId);
};

export const logError = (e: Error | ApolloError) => {
  if (config.env !== 'development') {
    Sentry.captureException(e);
  } else {
    // Log errors to console in development for easier debugging
    console.error('Sentry (Dev Mode): Would capture error:', e);
  }
};
